export const GET_BUSINESSES = 'GET_BUSINESSES';
export const STORE_BUSINESSES = 'STORE_BUSINESSES';
export const TOGGLE_SELECTED_BUSINESS_SERVICE = 'TOGGLE_SELECTED_BUSINESS_SERVICE';
export const CLEAR_SELECTED_BUSINESS_SERVICES = 'CLEAR_SELECTED_BUSINESS_SERVICES';
export const GET_BUSINESS_BOOKINGS = 'GET_BUSINESS_BOOKINGS';
export const CREATE_BOOKING = 'CREATE_BOOKING';
export const GET_BUSINESS_BY_ID = 'GET_BUSINESS_BY_ID';
export const STORE_SELECTED_BUSINESS = 'STORE_SELECTED_BUSINESS';


